module.exports = __webpack_public_path__ + "static/media/taxi.77abec3d.svg";